import React from 'react';
import '../../../../styles/AboutKumbh.css';
import PropTypes from 'prop-types';

const AboutKumbh = ({ data, customClass = '' }) => {
  const { title, description } = data;

  return (
    <div className={`rlAbout ${customClass ? customClass : ''}`}>
      {title && <h3 className="blackText latoBlack">{title}</h3>}
      {description && <p className="blackText">{description}</p>}
    </div>
  );
};

AboutKumbh.propTypes = {
  data: PropTypes.object,
  customClass: PropTypes.string
};

export default AboutKumbh;
